module.exports = __webpack_public_path__ + "media/home-sparkle-bg-small.963c926a.png";